import { render, staticRenderFns } from "./Somos1ReportListPage.vue?vue&type=template&id=74a2b705&scoped=true"
import script from "./Somos1ReportListPage.vue?vue&type=script&lang=js"
export * from "./Somos1ReportListPage.vue?vue&type=script&lang=js"
import style0 from "./Somos1ReportListPage.vue?vue&type=style&index=0&id=74a2b705&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2b705",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a2b705')) {
      api.createRecord('74a2b705', component.options)
    } else {
      api.reload('74a2b705', component.options)
    }
    module.hot.accept("./Somos1ReportListPage.vue?vue&type=template&id=74a2b705&scoped=true", function () {
      api.rerender('74a2b705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/Somos1ReportListPage.vue"
export default component.exports